if($('.type-detail').length){
    $('.extended-description .detail-parameters th').each(function() {
        $(this).closest('tr').find('td').html($(this).closest('tr').find('td').html().replace(/\|/g, '<br>'))
        var thText = $(this).text().trim();
        if (thText.includes('#Tab-')) {
            $(this).closest('tr').hide()
            var tabName = thText.split('#Tab-')[1].trim().split(':')[0];
            var tabid = tabName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            $('#p-detail-tabs li').first().after('<li class="shp-tab" data-testid="tab'+tabid+'" data-width=""><a href="#product'+tabid+'" class="shp-tab-link" role="tab" data-toggle="tab">'+tabName+'</a></li>')
            var tip = $(this).closest('tr').find('td').html()
         
            if($(this).closest('tr').find('th span.question-tooltip').length){
                tip += '<div class="superTooltip"><blockquote>'+$(this).closest('tr').find('th span.question-tooltip').attr('title')+'</blockquote></div>'
            }
            $('#tab-content').append('<div id="product'+tabid+'" class="tab-pane fade" role="tabpanel">'+tip.replace(/\|/g, '<br>')+'</div>');
        }
    });
}